import { keys } from 'mobx';

const compareArrays = (cloneArr, sourceArr, cb) =>
  cloneArr.every((el, key) => {
    if (typeof el === 'object') {
      return cb(el, sourceArr[key] || []);
    }
    if (el === cloneArr[key] || (el === '' && sourceArr[key] === null)) {
      return true;
    }

    return false;
  });

const compareValues = (clone, source) => {
  if (clone && source) {
    return keys(clone).every(key => {
      if (Array.isArray(clone[key])) {
        return compareArrays(clone[key], source[key], compareValues);
      }
      if (clone[key] === source[key] || (clone[key] === '' && source[key] === null)) {
        return true;
      }
      return false;
    });
  }
  return true;
};

export default compareValues;
